import ChevronIcon from '@/icons/chevron.svg';

export function CollapseIcon({ onCollapse }: { onCollapse: () => void }) {
  return (
    <ChevronIcon
      onClick={onCollapse}
      style={{
        cursor: 'pointer',
        transform: `rotate(270deg)`,
        flexShrink: 0,
        color: 'var(--mantine-color-dark-9)',
      }}
    />
  );
}
